module.exports = __webpack_public_path__ + "img/krathong_2.05bab1cc.png";